module.exports = __webpack_public_path__ + "static/media/mode-521.2575c3a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-521.svg
// module id = 1064
// module chunks = 2